import { type ReactNode } from "react";

import { twMerge } from "@/utils/twMerge";

/** The sidebar toggle that shows the floating chat input again, focused once the input is hidden. */
export const SHOW_CHAT_INPUT_ID = "show-chat-input";
/** The mobile button that shows the floating chat input, where the sidebar toggle is hidden */
export const SHOW_CHAT_INPUT_MOBILE_ID = "show-chat-input-mobile";

/** Focuses whichever show-chat-input button is rendered; the sidebar toggle has no box on mobile */
export function focusShowChatInput() {
  for (const id of [SHOW_CHAT_INPUT_ID, SHOW_CHAT_INPUT_MOBILE_ID]) {
    const button = document.getElementById(id);
    if (button && (button.checkVisibility?.() ?? true)) {
      button.focus();
      return;
    }
  }
}

type Props = {
  id?: string;
  className?: string;
  label?: string;
  onClick?: () => void;
  children: ReactNode;
};

export function VisibilityToggle({ id, className, label, onClick, children }: Props) {
  return (
    <button
      id={id}
      aria-label={label}
      type="button"
      className={twMerge(
        "group flex items-center justify-center w-[30px] h-[30px] bg-gray-50 dark:bg-gray-900 hover:bg-sidebar-button-active-bg",
        className,
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
